import axios from 'axios'

const AuthA = (dispatch) => {
  return {
    signup: (data) => {
      axios.post(process.env.REACT_APP_REG_URL, data)
        .then((response) => {
          axios.post(process.env.REACT_APP_LOGIN_URL, data)
            .then((response) => {
              localStorage.setItem('user', data.username)
              localStorage.setItem('token', response.data.id)
              localStorage.setItem('userId', response.data.userId)
              dispatch({type: 'LOGIN'})
            })
            .catch((err) => {
              console.log(err);
              dispatch({type: 'LOGIN_ERR'})
            })
        })
        .catch((err) => {
          console.log(err);
          dispatch({type: 'SIGNUP_ERR'})
        })
    },
    login: (data) => {
      axios.post(process.env.REACT_APP_LOGIN_URL, data)
        .then((response) => {
          localStorage.setItem('user', data.username)
          localStorage.setItem('token', response.data.id)
          localStorage.setItem('userId', response.data.userId)
          dispatch({type: 'LOGIN'})
        })
        .catch((err) => {
          console.log(err);
          dispatch({type: 'LOGIN_ERR'})
        })
    },
    logout: () => {
      localStorage.clear()
      dispatch({type: 'LOGOUT'})
    },

    getToken: () => {
      const url = process.env.REACT_APP_BASE_USER+'/'+localStorage.getItem('userId')
      axios.get(url, {
        params: {
          access_token: localStorage.getItem('token')
        }
      })
      .then((response) => {
        const auth = true;
        dispatch({
          type: 'GET_TOKEN',
          auth: auth,
          username: response.data.username,
          userType: response.data.type,
          levelType: response.data.level,
          userId: response.data.teacherId
        })
      })
      .catch((err) => {
        console.log(err);
        localStorage.clear()
        dispatch({type: 'LOGOUT'})
      })
    }

  }

}

export default AuthA;
